<template>
  <fragment>
    <v-card max-width="272" height="481">
      <v-card-text class="pa-0 fill-height">
        <div>
          <v-img :src="`${publicPath}images/shape-recoval.png`" width="272" height="261">
            <v-row class="fill-height" justify="center" align-content="center">
              <div class="white-circle">
                <v-img :src="require(`../assets/brand_logos/${brand.imgPath}`)"
                       height="120"
                       width="120"
                       class="mx-auto"
                       @click="$router.push(`/services/brands/${brand.id}`)"
                       style="cursor: pointer;">
                </v-img>
              </div>
            </v-row>
          </v-img>
        </div>
        <v-row justify="center" align-content="space-between" style="height: 220px;" class="mx-0 pb-3">
          <v-col cols="12" class="title font-weight-medium text-center black--text">
            {{ brand.brandName }}
          </v-col>
          <v-col cols="12" v-if="brand.productGroups.length > 0">
            <div class="caption text-center mb-4">
              {{ $t('serviceProducts') }}
            </div>
            <v-row justify="center">
              <template v-for="(item, index) in brand.productGroups">
                <v-tooltip top :key="index">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="mx-2">
                      {{ ICONS[item.brandProductGroupId].icon }}
                    </v-icon>
                  </template>
                  <span>
                    {{ $t(item.productGroupTitle) }}
                  </span>
                </v-tooltip>
              </template>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row class="mx-0" justify="center">
              <v-btn class="primary" @click="$router.push(`/services/brands/${brand.id}`)">
                {{ $t('button.next') }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </fragment>
</template>

<script>
import { PRODUCT_GROUP_ICONS } from '../plugins/appConst';

export default {
  name: 'brandCard',
  props: {
    brand: Object,
  },
  data() {
    return {
      ICONS: PRODUCT_GROUP_ICONS,
      show: false,
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
